import { writable } from 'svelte/store';

export const videoExpanded = writable(false);
export const videoNote = writable(null);
export const activeCalendarEvent = writable(null);
export const videoHistoryExpanded = writable(false);
/**
 * Expands the video, and sets an active calendar event
 *
 * @param {number} calendarEventId - The ID of the calendar event to expand the video for.
 * @returns {void}
 */
export const expandVideo = (calendarEventId) => {
  activeCalendarEvent.set({ id: calendarEventId });
  videoExpanded.set(true);
  videoHistoryExpanded.set(false);
};

export const expandVideoHistory = (calendarEventId) => {
  activeCalendarEvent.set({ id: calendarEventId });
  videoHistoryExpanded.set(true);
  videoExpanded.set(false);
};

export const closeVideo = () => videoExpanded.set(false);
export const toggleVideo = () => videoExpanded.update((value) => !value);

export const closeVideoHistory = () => videoHistoryExpanded.set(false);
export const toggleVideoHistory = () =>
  videoHistoryExpanded.update((value) => !value);
